import {
    CordwoodGroupQueryResult, CordwoodStorageGroup, createCordwoodClassGroup,
    createCordwoodCuttingGroup, createCordwoodStorageGroup
} from "./CordwoodGroups.ts";
import {
    createTimberClassGroup, createTimberCuttingGroup,
    createTimberStorageGroup,
    createTimberThicknessGroup,
    LogGroupQueryResult,
    TimberStorageGroup
} from "./LogGroups.ts";
import {ID} from "../../../types/global.d";
import {timberTypeApi} from "../../apis/TimberType.api.ts";
import {PrimaryTimberType} from "./TimberType.ts";
import {TreeMarking} from "./TreeMarking.ts";
import {timberStorageApi} from "../../apis/TimberStorage.api.ts";
import {PrimaryCutting} from "./Cutting.ts";
import {cuttingApi} from "../../apis/Cutting.api.ts";

export interface GroupQueryRequest {
    classId?: ID[],
    typeId?: ID[],
    buyerId?: ID,
    ownerId?: ID,
    cuttingId?: ID,
    storageId?: ID[],
    shipmentId?: ID,
    shipmentDefined?: boolean,
    startCreate?: Date,
    endCreate?: Date,
    startShipment?: Date,
    endShipment?: Date,
}

export interface WoodGroupsList {
    items: Array<CordwoodStorageGroup | TimberStorageGroup>,
    itemMap: Record<string, CordwoodStorageGroup | TimberStorageGroup>
    count: number,
    sum: number,
    isLoading: boolean,
}

const createWoodGroupsList = (): WoodGroupsList => {
    return {
        items: [],
        itemMap: {},
        count: 0,
        sum: 0,
        isLoading: true,
    } as WoodGroupsList
}

export const fetchTreeMarking = async (dispatch, items: TreeMarking[]): Promise<TreeMarking> => {
    let groupList = []
    for (const item of items) {
        groupList.push({
            ...item,
            timberType: (await dispatch(timberTypeApi.endpoints.getTimberType.initiate(PrimaryTimberType.fromId(item.timberTypeId))))?.data,
            storage: (await dispatch(timberStorageApi.endpoints.getTimberStorage.initiate(PrimaryTimberType.fromId(item.storageId))))?.data,
            cutting: (await dispatch(cuttingApi.endpoints.getCutting.initiate(PrimaryCutting.fromId(item.cuttingId))))?.data,
        })
    }
    return groupList
}

const fetchCordwoodData = async (dispatch, timberData: Array<CordwoodGroupQueryResult>, groupList: WoodGroupsList) => {
    if (!Array.isArray(timberData)) return;
    for (const item of timberData) {
        const key0 = item.cuttingId
        let current0 = groupList.itemMap[key0]
        if (!current0) {
            const group = await createCordwoodCuttingGroup(dispatch, item)
            groupList.itemMap[key0] = group
            groupList.items.push(group)
        } else {
            const key1 = item.storageId
            let current1 = current0.itemMap[key1]
            if (!current1) {
                const group = await createCordwoodStorageGroup(dispatch, item)
                current0.itemMap[key1] = group
                current0.items.push(group)
            } else {
                const key2 = item.timberClassId + '_' + item.timberTypeId
                const current2 = current1.itemMap[key2]
                if (!current2) {
                    const group = await createCordwoodClassGroup(dispatch, item)
                    current1.itemMap[key2] = group
                    current1.items.push(group)
                    current1.sum += group.sum
                } else {
                    current2.sum += item.totalVolume
                }
            }
            current0.sum += item.totalVolume
        }
        groupList.sum += item.totalVolume
    }
}

const fetchLogData = async (dispatch, timberData: Array<LogGroupQueryResult>, groupList: WoodGroupsList) => {
    if (!Array.isArray(timberData)) return;
    for (const item of timberData) {
        const key0 = item.cuttingId
        let current0 = groupList.itemMap[key0]
        if (!current0) {
            const group = await createTimberCuttingGroup(dispatch, item)
            groupList.itemMap[key0] = group
            groupList.items.push(group)
        } else {
            const key1 = item.storageId
            let current1 = current0.itemMap[key1]
            if (!current1) {
                const group = await createTimberStorageGroup(dispatch, item)
                current0.itemMap[key1] = group
                current0.items.push(group)
            } else {
                const key2 = item.timberClassId + '_' + item.timberTypeId
                const current2 = current1.itemMap[key2]
                if (!current2) {
                    const group = await createTimberClassGroup(dispatch, item)
                    current1.itemMap[key2] = group
                    current1.items.push(group)
                } else {
                    current2.items.push(await createTimberThicknessGroup(dispatch, item))
                    current2.sum += item.totalVolume
                    current2.count += item.totalCount
                }
                current1.sum += item.totalVolume
                current1.count += item.totalCount
            }
            current0.sum += item.totalVolume
            current0.count += item.totalCount
        }
        groupList.sum += item.totalVolume
        groupList.count += item.totalCount
    }
}

const fetchWoodData = async (dispatch, timberData: Array<LogGroupQueryResult>, cordwoodData: Array<CordwoodGroupQueryResult>): Promise<WoodGroupsList> => {
    let groups = createWoodGroupsList()
    await fetchLogData(dispatch, timberData, groups)
    await fetchCordwoodData(dispatch, cordwoodData, groups)
    return groups
}

export {
    createWoodGroupsList,
    fetchLogData,
    fetchCordwoodData,
    fetchWoodData,
}
